import {Component, Input, OnInit} from '@angular/core';
import {BackendService} from "@app/core/backendService/backend.service";
import {Participant} from "@app/shared/models/Participant";
import {DatePipe} from "@angular/common";
import {Purchase, Reward} from "@app/feature/reward/models/Reward";
import {RewardService} from "@app/feature/reward/service/reward.service";
import {Observable} from "rxjs";

@Component({
  selector: 'app-participant-detail-card',
  templateUrl: './participant-detail-card.component.html',
  styleUrls: ['./participant-detail-card.component.scss'],
  providers: [DatePipe]
})
export class ParticipantDetailCardComponent implements OnInit {

  constructor(
    public backendService: BackendService,
    public rewardService: RewardService
  ) {
    this.purchase$ = rewardService.purchase$
  }

  public purchase$: Observable<Purchase[]>

  @Input('participantID')
  set participantID(participantID: number){
    this.participant_detail(participantID)
  }
  public date: DatePipe

  public participant: Participant
  public isSyncInProgress: boolean = true
  public purchase:Purchase[]

  ngOnInit() {}

  participant_detail(participantID:number){

    this.backendService.get_participant_detail(participantID).subscribe(
      (res:Participant)=>{
        this.participant = res
      },
      (err)=>{
      },
      ()=>{ this.isSyncInProgress = false }
    )

    // this.rewardService.get_purchases(participantID).subscribe(
    //   (purchase:Purchase[])=>{
    //     this.purchase = purchase
    //   }
    // )
  }

  isDummyEmail(email:string) { return this.backendService.isDummyEmail(email) }
  isDummyName(name:string){ return this.backendService.isDummyName(name) }


}
